define('../app/fukit/service/a11y.announcement.service',['require','exports','module','appkit/appkit','backbone.radio','../view/app.a11y.announcements.view'],function(require, exports, module) {
  //prettier-ignore
  var AppKit                 = require('appkit/appkit'),
      Radio                  = require('backbone.radio'),
      AnnouncementRegionView = require('../view/app.a11y.announcements.view');

  var A11yAnnouncementService = {
    radioEvents: {
      'app start': 'onAppStart',
      'app ready': 'onAppReady',
    },

    radioRequests: {
      'App.A11y announce': 'announce',
    },

    onAppStart: function() {
      //Pre-build the AnnouncementRegionView when the app starts
      this.announcementRegionView = new AnnouncementRegionView();
    },

    onAppReady: function() {
      //When the app is "ready", inject the AnnouncementRegionView into the layout
      var layout = Radio.channel('layoutConfiguration').request('layout');

      layout.showChildView('a11yAnnouncements', this.announcementRegionView);
    },

    //Radio request method for passing announcements and aria-live manners to the view
    announce: function(announcement, ariaLive) {
      this.announcementRegionView.announce(announcement, ariaLive);
    },
  };

  module.exports = A11yAnnouncementService;
});

